// Automatische Erkennung der Umgebung
const getApiConfig = () => {
  // Wenn wir im Development-Modus sind oder auf localhost laufen
  if (process.env.NODE_ENV === 'development' || 
      window.location.hostname === 'localhost' || 
      window.location.hostname === '127.0.0.1') {
    return {
      API_HOST: 'http://127.0.0.1',
      API_PORT: 3001
    };
  }
  
  // Für Production: Verwende die feste Backend-URL
  return {
    API_HOST: 'https://lepapi.bws-uster.ch',
    API_PORT: 443
  };
};

const apiConfig = getApiConfig();

const config = {
  API_HOST: apiConfig.API_HOST,
  API_PORT: apiConfig.API_PORT,
  API_KEY: 'md93qq6VMt0V6Me4NagDCaYNkzQdgvTBgNP3OkOrPmyEcLagYRm9YuX3lRA2Y7oD',
  START_DATE: '2025-08-18',
  PLANS: {
    MAX_VERSIONS: 10  // Maximale Anzahl Versionen pro Plan
  },
  AUTOSAVE: {
    INTERVAL_MS: 10000  // Autosave-Intervall in Millisekunden (10 Sekunden)
  }
};

export default config;